angular.module('app.factories').factory('clientsListFilterFactory', ($translate, $state, $log, listFilter) => {
    const clientsListFilter = listFilter;

    clientsListFilter
        .setAttributes({
            name: 'clientsListFilter',
            providers: ['usersOptions'],
        })
        .setFields({
            filter: {
                type: 'text',
                class: 'uk-width-medium-10-10',
                label: $translate.instant('search'),
                default: '',
            },
            search_in: {
                type: 'checkbox-list',
                class: 'uk-width-medium-4-10',
                label: $translate.instant('search_in'),
                names: [
                    { name: 'name', label: $translate.instant('clients.name') },
                    { name: 'nip', label: $translate.instant('clients.nip') },
                    { name: 'email', label: $translate.instant('clients.email') },
                    { name: 'address_city', label: $translate.instant('clients.address_city') },
                ],
                default: { name: true },
            },
            author_id: {
                type: 'multiuserlist',
                operator: 'in',
                class: 'uk-width-medium-6-10',
                label: $translate.instant('clients.author_id'),
                optionsProvider: 'usersOptions',
                options: [],
                default: '',
            },
        })
        .onRefresh(() => {
            const filterParams = clientsListFilter.getValues(true);
            $log.debug('--> apply filter', filterParams);
            $state.applyFilter(filterParams);
        })
        .ready();

    return clientsListFilter;
});
